import { useEffect, useState } from 'react';
import './index.scss';

// ============================================================
// CONFIGURAÇÃO DO AGENTFORCE (Salesforce Embedded Messaging)
// ============================================================
// Preencha os valores abaixo com as configurações do seu deployment.
// Você encontra todos esses dados em:
//   Salesforce Setup → Embedded Service Deployments → [seu deployment] → View
//
// Enquanto as configurações não forem preenchidas o chatbot não será carregado,
// mas o botão de toggle já fica visível e funcional.
// ============================================================
const AGENTFORCE_CONFIG = {
    orgId: '00Dg5000000gDiU',
    deploymentName: 'ServiceAgentSDE',

    // URL oficial do deployment (conforme code snippet do Salesforce)
    siteURL: 'https://orgfarm-dbbf51cf56-dev-ed.develop.my.site.com/ESWServiceAgentSDE1764601126830',

    scrt2URL: 'https://orgfarm-dbbf51cf56-dev-ed.develop.my.salesforce-scrt.com',

    // Script oficial do deployment (conforme code snippet do Salesforce)
    bootstrapURL: 'https://orgfarm-dbbf51cf56-dev-ed.develop.my.site.com/ESWServiceAgentSDE1764601126830/assets/js/bootstrap.min.js',
};

const CONFIG_PREENCHIDA = AGENTFORCE_CONFIG.orgId !== 'SEU_ORG_ID';
const CHAT_HABILITADO = false;

// Seletores dos elementos que o Salesforce Messaging for Web injeta no DOM
// A v2 usa custom elements (web components) com estes nomes
const CHAT_SELECTORS = [
    'embeddedservice-bootstrap',
    '.embedded-messaging',
    '#esw-container',
    '#embeddedMessagingFrame',
    '.embeddedServiceHelpButton',
    '.embeddedServiceSidebar',
    '[class*="embeddedMessaging"]',
    '[class*="embedded-messaging"]',
];

function setChatVisibility(visible) {
    CHAT_SELECTORS.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
            el.style.display = visible ? '' : 'none';
        });
    });
    // Também tenta pegar via shadow DOM / iframe do Salesforce
    const iframes = document.querySelectorAll('iframe[name*="ESW"], iframe[title*="chat"], iframe[title*="Chat"], iframe[title*="message"], iframe[title*="Message"]');
    iframes.forEach(el => {
        el.style.display = visible ? '' : 'none';
    });
}

export default function SalesforceAgentforce() {
    const [chatAtivo, setChatAtivo] = useState(
        () => localStorage.getItem('agentforce_ativo') !== 'false'
    );

    // Carrega e inicializa o script do Salesforce
    useEffect(() => {
        if (!CHAT_HABILITADO) return;
        if (!CONFIG_PREENCHIDA) return;

        function initEmbeddedMessaging() {
            if (window.__agentforceInitDone) return;
            try {
                window.embeddedservice_bootstrap.settings.language = 'pt_BR';
                window.embeddedservice_bootstrap.init(
                    AGENTFORCE_CONFIG.orgId,
                    AGENTFORCE_CONFIG.deploymentName,
                    AGENTFORCE_CONFIG.siteURL,
                    { scrt2URL: AGENTFORCE_CONFIG.scrt2URL }
                );
                window.__agentforceInitDone = true;
            } catch (err) {
                console.error('Erro ao inicializar Agentforce:', err);
            }
        }

        const existing = document.querySelector('script[data-agentforce="fracaro"]');
        if (existing) {
            if (window.embeddedservice_bootstrap) {
                initEmbeddedMessaging();
                setChatVisibility(chatAtivo);
            }
            return;
        }

        const script = document.createElement('script');
        script.src = AGENTFORCE_CONFIG.bootstrapURL;
        script.setAttribute('data-agentforce', 'fracaro');
        script.onload = () => {
            // O bootstrap pode precisar de um momento para registrar o objeto global
            const tryInit = (attempts = 0) => {
                if (window.embeddedservice_bootstrap) {
                    initEmbeddedMessaging();
                    setTimeout(() => setChatVisibility(chatAtivo), 1200);
                } else if (attempts < 20) {
                    setTimeout(() => tryInit(attempts + 1), 200);
                } else {
                    console.error('embeddedservice_bootstrap não ficou disponível após o script carregar.');
                }
            };
            tryInit();
        };
        script.onerror = () =>
            console.error('Falha ao carregar o script do Agentforce. Verifique a bootstrapURL.');
        document.body.appendChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Aplica/remove visibilidade sempre que chatAtivo muda
    useEffect(() => {
        if (!CHAT_HABILITADO) return;
        setChatVisibility(chatAtivo);
    }, [chatAtivo]);

    const toggleChat = () => {
        setChatAtivo(prev => {
            const next = !prev;
            localStorage.setItem('agentforce_ativo', String(next));
            return next;
        });
    };

    if (!CHAT_HABILITADO) {
        return null;
    }

    return (
        <button
            className={`agentforce-toggle ${chatAtivo ? 'ativo' : 'inativo'}`}
            onClick={toggleChat}
            title={chatAtivo ? 'Desativar chat' : 'Ativar chat'}
            aria-label={chatAtivo ? 'Desativar chat' : 'Ativar chat'}
        >
            {/* Ícone chat */}
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {/* Ícone X quando inativo */}
            {!chatAtivo && (
                <svg className="slash-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                </svg>
            )}
        </button>
    );
}
